import React from 'react'
import {connect} from 'react-redux'
import {Dialog, Mask, Button, ButtonArea} from 'react-weui'
import qr from 'qr-encode'
import axios from 'axios'
import qs from 'qs'


import '../styles/SubscribeLecture.css'


class SubscribeLecture extends React.Component {
    hide() {
        this.props.dispatch({type: 'HIDE_SUBSCRIBE_LECTURE'})
    }

    subscribeLecture() {
        const {subscribeLecture, lectureId} = this.props
        let data = {
            fr: 'room',
            chatid: lectureId,
        };
        axios.post(`/api/lecture/${subscribeLecture.lecture.id}/subscribe`, qs.stringify(data)).then((response) => {
            if (response.data.code === 0) {
                this.props.dispatch({
                    type: 'SUBSCRIBE_LECTURE',
                    payload: {
                        lecture_id: subscribeLecture.lecture.id
                    }
                })
                this.hide()
                this.context.page.showToast('预约成功')
                subscribeLecture.callback && subscribeLecture.callback()
            }
        })
    }

    render() {
        const {subscribeLecture, account} = this.props
        if (!subscribeLecture.showSubscribeLecture)
            return null

        if (!account.subscribed)
            return <Dialog show={true} type="ios"
                           title={'预约' + subscribeLecture.lecture.name}
                           buttons={[{
                               label: '关闭',
                               type: 'default',
                               onClick: this.hide.bind(this)
                           }]}>
                <p className="follow-tips">长按识别二维码，预约开课提醒</p>
                <p className="follow-qrcode"><img className="qrcode-img" src={qr(subscribeLecture.lectureQrcode)} alt="subscribe"/></p>
            </Dialog>

        const {lecture} = subscribeLecture
        return <div className="subscribe-lecture">
            <Mask onClick={this.hide.bind(this)}/>
            <div className="dialog">
                <div className="avatar">
                    <div className="cover" style={{backgroundImage: `url(${lecture.cover_url})`}}>
                    </div>
                </div>
                <div className="name">
                    {lecture.name}
                </div>
                <div className="description">
                    预约开课提醒，可在开课2小时前以及5分钟前收到公众号推送的上课通知，不怕错过直播！
                </div>
                <ButtonArea>
                    <Button onClick={this.subscribeLecture.bind(this)}>预约</Button>
                </ButtonArea>
            </div>
        </div>
    }
}


SubscribeLecture.contextTypes = {
    page: React.PropTypes.object
};


export default connect((state) => ({
    subscribeLecture: state.subscribeLecture,
    account: state.account,
		lectureId: state.classroom.lecture.id,
}))(SubscribeLecture)




// WEBPACK FOOTER //
// ./src/components/SubscribeLecture.js